<template>
  <div class="page-content">
<!--    <el-button type="primary" @click="addInfo">创建直播间</el-button>-->
<!--    <el-button type="primary" @click="editInfo">编辑</el-button>-->
<!--    <el-button type="primary" plain @click="roomGoodsInsert">导入商品</el-button>-->
<!--    <el-button type="primary" @click="playback">直播回放</el-button>-->
<!--    <el-button type="primary" @click="pushAddress">获取推流地址</el-button>-->
<!--    <el-button type="primary" @click="Qrcode">开播码</el-button>-->
<!--    <el-button type="primary" @click="sharedCode">直播间分享二维码</el-button>-->
<!--    <el-button type="primary" @click="goodsCheck">商品查看</el-button>-->
    <page-template
      ref="liveRoomTemplate"
      :tableOptions="tableOptions"
      :searchOptions="searchOptions"
      :toolConfig="toolConfig"
    ></page-template>
    <el-dialog title="商品列表" :visible.sync="listShow" width="1000px" height="800" :close-on-click-modal="false">
      <el-button type="primary" plain @click="save" style="margin-bottom: 10px">导入</el-button>
      <table-template
        v-if="listShow"
        ref="goodList"
        :tableOptions="goodsOptions"
      ></table-template>
    </el-dialog>
<!--    直播二维码-->
    <el-dialog title="开播二维码" :visible.sync="showQrcode">
      <div style=";text-align: center">
        <img src="/static/liveQrcode.jpg" alt="" style="width: 50%">
      </div>
    </el-dialog>
    <!--    直播商品查看-->
    <el-dialog title="直播商品" :visible.sync="goodsCheckShow">
      <list-template
        v-if="goodsCheckShow"
        ref="liveGoodList"
        :tableOptions="liveGoodOptions"
        :tableData="goodsData"
      >
      </list-template>
    </el-dialog>
    <!--    直播回放查看-->
    <el-dialog title="直播回放" :visible.sync="replayShow" width="1000px">
      <list-template
        v-if="replayShow"
        ref="replayShow"
        :tableOptions="replayOptions"
        :tableData="replayData"
      >
      </list-template>
    </el-dialog>
    <!--    推流地址-->
    <el-dialog title="推流地址" :visible.sync="pushUrlShow" width="1000px">
      <div style="padding:20px">{{pushUrl}}</div>
    </el-dialog>
  </div>
</template>
<script>
import pageTemplate from '@/components/template/pageTemplate';
import listTemplate from "@/components/template/listTemplate";
import api from '@/config/api';
import qs from 'qs'
export default {
  components: {
    pageTemplate,listTemplate
  },
  data() {
    return {
      pushUrl:'',
      pushUrlShow:false,
      replayData:[],
      replayShow:false,
      goodsData:[],
      showQrcode:false,
      listShow:false,
      // 搜索条件
      searchOptions: {
        simple: [
          // {label: '门店编码', prop: 'code', type: 'input', isFuzzy: true, placeholder: "请输入门店编码"},
          {label: '门店名称', prop: 'name', type: 'input', isFuzzy: true, placeholder: "直播间名称/主播名称/房间号"}
        ]
      },
      // 更多功能
      toolConfig: [
        {
          label: '编辑',
          type: this.$utils.buttonType.tableOperate,
          code: 'update',
          callback: this.editInfo,
          // filter:(data)=>{
          //   console.log(new Date().getTime() - data.start_time)
          //   // if(new Date().getTime() - data.start_time > )
          // }
        },
        {
          label: '创建直播间',
          type: this.$utils.buttonType.tableOperate,
          code: 'insert',
          callback: this.addInfo,
        },
        {
          label: '商品导入',
          type: this.$utils.buttonType.tableOperate,
          code: 'liveGoodsImport',
          callback: this.roomGoodsInsert,
        },
        {
          label: '直播回放',
          type: this.$utils.buttonType.tableOperate,
          code: 'liveReplay',
          callback: this.playback,
        },
        {
          label: '商品查看',
          type: this.$utils.buttonType.tableOperate,
          code: 'liveGoodsDetail',
          callback: this.goodsCheck,
        },
        {
          label: '推流地址',
          type: this.$utils.buttonType.tableOperate,
          code: 'livePushUrl',
          callback: this.pushAddress,
        },
        {
          label: '开播码',
          type: this.$utils.buttonType.tableOperate,
          code: 'liveOpen',
          callback: this.Qrcode,
        },
        {
          label: '分享码',
          type: this.$utils.buttonType.tableOperate,
          code: 'cdnUrl',
          callback: this.sharedCode,
        },
        {
          label: '删除',
          type: this.$utils.buttonType.tableOperate,
          code: 'delete',
          callback: this.deleteInfo
          // filter:()=>{
          //   return false
          // }
        },
      ],
      // 选择 导入的商品列表
      goodsOptions:{
        // selectEnable:true,//开启多选禁用
        showSelect: true,
        indexShow: true,//是否显示索引
        indexMethod: (index) => {//自定义列索引
          return index + 1;
        },
        columns: [
          {
            label: '商品名称',
            prop: 'name',
            align: 'center',
            width: '100',
          },
          {
            label: '价格',
            prop: 'price',
            align: 'center',
            width: '150',
            deal: this.newPrice,
          },
          // {label: '商品图片', prop: 'coverImgUrl', width: '60', align: 'center', type: 'image'},
        ],
        layout:'sizes, prev, pager, next',
        pageList:[10, 20, 30, 40,100],
        liveSet:true,//直播间
        param:{
          offset:0,
          limit:10,
          status:2
        },
        url:api.mall.mallLiveGoodsList
      },
      // 直播回放 列表
      replayOptions:{
        indexShow: true,//是否显示索引
        indexMethod: (index) => {//自定义列索引
          return index + 1;
        },
        columns: [
          {
            label: '创建时间',
            prop: 'create_time',
            align: 'center',
            width: '100',
            deal:this.time1
          },
          {
            label: '视频地址',
            prop: 'media_url',
            align: 'center',
            width: '300',
          },
      ]
      },
      //查看 直播商品
      liveGoodOptions:{
        indexShow: true,//是否显示索引
        indexMethod: (index) => {//自定义列索引
          return index + 1;
        },
        columns: [
          {
            label: '商品名称',
            prop: 'name',
            align: 'center',
            width: '100',
          },
          {
            label: '价格',
            prop: 'price',
            align: 'center',
            width: '150',
            deal: this.newPrice,
          },
          // {label: '商品图片', prop: 'coverImgUrl', width: '60', align: 'center', type: 'image'},
          // {
          //   label: '创建时间',
          //   prop: 'createDttm',
          //   align: 'center',
          //   width: '120',
          // },
        ],
      },
      // 表格信息配置
      tableOptions: {
        // showSelect: true,
        indexShow: true,//是否显示索引
        indexMethod: (index) => {//自定义列索引
          return index + 1;
        },
        columns: [
          {
            label: '直播间名称',
            prop: 'name',
            align: 'center',
            width: '100',
          },
          {
            label: '房间号',
            prop: 'roomid',
            align: 'center',
            width: '100',
          },
          {
            label: '直播状态',
            prop: 'live_status',
            width: '80',
            align: 'center',
            enumData: this.$utils.getCacheStatus('mallLiveRoom.liveStatus')
          },
          {
            label: '主播',
            prop: 'name',
            align: 'center',
            width: '100',
          },

          {
            label: '开播时间',
            prop: 'start_time',
            align: 'center',
            width: '120',
            deal:this.timer1
          },
          {
            label: '结束时间',
            prop: 'end_time',
            align: 'center',
            width: '120',
            deal:this.timer2
          },
          // {label: '直播封面', prop: 'feeds_img', width: '60', align: 'center', type: 'image'},
          // {label: '直播背景', prop: 'cover_img', width: '60', align: 'center', type: 'image'},
        ],
        layout:'sizes, prev, pager, next',
        pageList:[10, 20, 30, 40,100],
        liveSet:true,//直播间
        param:{
          start:0,
          limit:10
        },
        url: '/api/eros/mall/mallLiveRoom/live/info'
      },
      form:{
        roomId:'',
        goodsList:[]
      },
      goodsCheckShow:false,
    };
  },
  created() {
  },
  mounted() {
  },
  methods: {
    // 转化时间
    shiftTime(val){
      let time = new Date(val)
      var y = time.getFullYear();
      var m = time.getMonth()+1;
      var d = time.getDate();
      var h = time.getHours();
      var mm = time.getMinutes();
      var s = time.getSeconds();
      return y+'-'+this.add0(m)+'-'+this.add0(d)+' '+this.add0(h)+':'+this.add0(mm)+':'+this.add0(s);
    },
    time1(row){
      return `<span class="" >${this.shiftTime(row.create_time)}</span>`;//2017-03-31T08:02:06Z
    },
    // table 商品价格
    newPrice(row){
      if(row.priceType ==1){
        return `<span class="" >${row.price}</span>`;
      }else if(row.priceType == 2){
        return `<span class="" >${row.price}~${row.price2}</span>`;
      }else{
        return `<span class="" >原价：${row.price}；折扣价：${row.price2}</span>`;
      }
    },
    // 商品查看
    goodsCheck(row){
      this.goodsData = []
      this.goodsCheckShow = true
      if(row.goods){
        this.goodsData = row.goods
      }
    },
    // 直播回放
    playback(row){
      this.replayData = []
      this.replayShow = true
      this.$axios.fetchPost(api.mall.replay,{roomId:row.roomid}).then(res=>{
        if(res.code == 200){
          if(res.data){
            this.replayData = res.data.live_replay
          }
        }else{
          this.$message.error(res.errorMsg)
        }
      }).finally(()=>{})
    },
    // 获取推流地址
    pushAddress(row){
      this.pushUrl = ''
      this.$axios.fetchPost(api.mall.pushUrl,{roomId:row.roomid}).then(res=>{
        if(res.code == 200){
          if(res.data){
            this.pushUrlShow = true
            this.pushUrl = res.data.pushAddr
          }
        }else{
          this.$message.error(res.errorMsg)
        }
      }).finally(()=>{})
    },
    // 直播间分享二维码
    sharedCode(row){
      this.$axios.fetchPost(api.mall.sharedCode,{roomId:row.roomid}).then(res=>{
        if(res.code == 200){
          if(res.data && res.data.cdnUrl){
            window.open(res.data.cdnUrl, "_blank");
          }
        }else{
          this.$message.error(res.errorMsg)
        }
      }).finally(()=>{})
    },
    // 开播码
    Qrcode(){
      this.showQrcode = true
    },
    //直播间导入商品
    roomGoodsInsert(row) {
      this.listShow = true
      this.form.roomId = row.roomid
    },
    // 确认导入
    save(){
      let tableRows = this.$refs.goodList.getTableSelectRow();
      if (tableRows.length === 0) {
        this.$message({message: '请选择要操作的数据', type: 'warning'});
      } else {
        this.form.goodsList = tableRows
        const loading = this.$loading({
          lock: true,
          text: '提交中，请稍候...',
          background: 'rgba(225, 225, 225, 0.8)',
        });
        this.$axios.fetchPost(api.mall.mallLiveGoodsImport,this.form).then(res=>{
          if(res.code == 200){
            this.listShow = false
            this.$refs.liveRoomTemplate.operationSuccess()
            // this.$message.success('导入成功')
            this.$notify({
              type: "success",
              title: '导入操作',
              message: '成功',
              showClose: false,
            });
          }else{
            this.$notify({
              type: "error",
              title: '导入操作',
              message: '失败',
              showClose: false,
            });
            // this.$message.error(res.errorMsg || '导入失败')
          }
        }).finally(()=>{
          loading.close()
        })
      }
    },
    //时间戳转化
    add0(m){return m<10?'0'+m:m },
    format(shijianchuo){
      //shijianchuo是整数，否则要parseInt转换,转化为北京时间必须要*1000
      var time = new Date(shijianchuo*1000);
      var y = time.getFullYear();
      var m = time.getMonth()+1;
      var d = time.getDate();
      var h = time.getHours();
      var mm = time.getMinutes();
      var s = time.getSeconds();
      return y+'-'+this.add0(m)+'-'+this.add0(d)+' '+this.add0(h)+':'+this.add0(mm)+':'+this.add0(s);
    },
    timer1(row){
      return `<span class="" >${this.format(row.start_time)}</span>`;
    },
    timer2(row){
      return `<span class="" >${this.format(row.end_time)}</span>`;
    },
    // 创建直播间
    addInfo(){
      this.$router.push('/mall/live/roomAdd')
    },
    // 编辑
    editInfo(row){
      this.$router.push({
        path: '/mall/live/roomAdd',
        query: {id:row.roomid}
       })
    },
    // 删除
    deleteInfo(row){
      this.$confirm('删除本条数据, 是否确认?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.fetchDelete(api.mall.mallLiveRoom+'?id='+row.roomid).then(res=>{
          if(res.code === 200){
            this.$notify({
              type: "success",
              title: '删除操作',
              message: '成功',
              showClose: false,
            });
            // this.$message.success('删除成功')
            this.$refs.liveRoomTemplate.operationSuccess()
          }else{
            this.$notify({
              type: "error",
              title: '删除操作',
              message: '失败',
              showClose: false,
            });
            // this.$message.error(res.errorMsg || '删除失败')
          }
        })
      }).catch(() => {});

    },
  }
};
</script>
<style scoped>
>>> .el-dialog__header{
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/page/system/applet/live/liveList.vue